/*
 * Job detail page utilities.
 * Ported from c2Archive/jobs.js (refreshJobPage and drawProgressBar and helpers).
 */
(function (__module__, c2, $) {
  'use strict';

  function isScrolledToBottom(elem) {
    return elem.scrollTop >= elem.scrollHeight - elem.offsetHeight;
  }

  function scrollToBottom(elem) {
    elem.scrollTop = elem.scrollHeight;
  }

  // Append only the new delta of remote-script output to the textarea,
  // preserving scroll position unless the user was already at the bottom.
  function updateRemoteScriptOutput(newVal) {
    if (newVal === undefined) { return; }
    var textarea = $('.currentOutput textarea').get(0);
    if (!textarea) { return; }
    var atBottom = isScrolledToBottom(textarea);
    textarea.value += newVal.substring(textarea.value.length);
    if (atBottom) { scrollToBottom(textarea); }
  }

  // Scroll the job-progress div to bottom if the user hadn't scrolled up.
  function updateProgressMessages(htmlNode, newVal) {
    if (newVal === undefined) { return; }
    var progressMsgDiv = htmlNode.get(0);
    if (!progressMsgDiv) { return; }
    if (isScrolledToBottom(progressMsgDiv)) { scrollToBottom(progressMsgDiv); }
  }

  /*
   * Update the job detail page after each polling interval.
   *
   * Args:
   *   job - job status object from /jobs/<id>/status/
   */
  function refreshJobPage(job) {
    document.title = job.title;
    $('#job-title').text(job.title);

    if (job.remoteScriptOutputs && job.remoteScriptOutputs.length > 0) {
      setTimeout(function() {
        updateRemoteScriptOutput(job.remoteScriptOutputs[0].outputString);
      }, 100);
    }

    if (job.progressStrings && job.progressStrings.length > 1) {
      setTimeout(function() {
        updateProgressMessages($('#job-progress'), job.progressStrings);
      }, 50);
    }

    // Enable server-card tooltips once they appear in the DOM.
    setTimeout(function() {
      c2.tooltips.init('.job-detail');
    }, 500);
  }

  function jobStatusToBootstrapContext(jobStatus) {
    var map = { success: 'success', warning: 'warning', failure: 'danger' };
    return map[(jobStatus || '').toLowerCase()] || 'info';
  }

  // Update a summary progress bar (on the order detail page) given a job
  // status object from /jobs/<id>/status/.
  function updateProgressBar(jobID, job) {
    var contextClass = jobStatusToBootstrapContext(job.status);
    var percent = job.percentDone || 0;
    var $progressBar = $('#progress-bar-' + jobID)
      .removeClass()
      .addClass('progress-bar bg-' + contextClass)
      .css('width', percent + '%')
      .attr('aria-valuenow', percent);

    // Written to a separate overlay spanning the whole track, not into
    // $progressBar itself -- that div's width is the fill percentage, so at
    // low percentages it's too narrow to hold the text without clipping it.
    if (job.duration) {
      $('#progress-label-' + jobID).text(job.duration);
    }

    if (job.isRunning) {
      $progressBar.addClass('progress-bar-striped progress-bar-animated');
    }

    var $wrapper = $('#progress-' + jobID).attr({
      'data-bs-toggle': 'tooltip',
      'title': 'Completed ' + job.tasksDone + ' of ' + job.totalTasks + ' tasks'
    });
    c2.tooltips.init($wrapper);
  }

  // Fetch current job status from server and update the summary progress bar.
  function drawProgressBar(jobID) {
    $.getJSON('/jobs/' + jobID + '/status/', function(data) {
      updateProgressBar(jobID, data);
    });
  }

  // formerly from progress-bars.js
  var noAnimationStyle = "<style>.progress-bar { -webkit-transition: none; transition: none; }</style>";
  var animationsEnabled = true;

  // Immediately disable progress bar animations.
  //
  // Used in job and order detail pages to disable the animation after the first page load, preventing re-animation from 0 when new progress bars are AJAX'd in
  function disableAnimations() {
    if (animationsEnabled) { // avoid a mem leak by only appending once
      $('head').append(noAnimationStyle);
      animationsEnabled = false;
    }
  }


  c2[__module__] = {
    drawProgressBar: drawProgressBar,
    refreshJobPage: refreshJobPage,
    disableAnimations: disableAnimations
  };

})('jobs', window.c2, window.jQuery);
